import { DestinationFeatureFlags, experiment } from '@lib/experiment';
import { IDestDefinition } from '@stores/destinationDefsList';

const VDM_V2_SCHEMA_VERSION = '1.1';
type VdmConnectionConfig = { destination?: Record<string, unknown> | null } | null;

export const isVdmNextEnabledForDestination = (
  destinationDefinition?: IDestDefinition,
): boolean => {
  if (!destinationDefinition) {
    return false;
  }

  const isSupportedByDefinition = Boolean(destinationDefinition.config?.supportsVisualMapperV2);

  const isEnabledByFeatureFlag = experiment.isDestinationFeatureEnabled(
    destinationDefinition.name,
    DestinationFeatureFlags.vdmNext,
  );

  return isEnabledByFeatureFlag || isSupportedByDefinition;
};

export const isVdmV2Connection = (config?: VdmConnectionConfig): boolean =>
  config?.destination?.schemaVersion === VDM_V2_SCHEMA_VERSION;
